import SAPOMailConfig          from "@/SAPOMailConfig";
import HTTPService             from "@/js/Shared/Services/HTTP/HTTPService";
import HTTPResponseEntity      from "@/js/Shared/Services/HTTP/Entities/HTTPResponseEntity";

export { IdentitiesHTTPService as default };

/**
* Settings Generic API Service
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class IdentitiesHTTPService {
  /**
   * Contacts Enpoint
   *
   * @public
   *
   * @type {string}
   *
   * @since 7.0.0
   */
  endpoints = SAPOMailConfig.client.endpoints.settings;

  /**
   * Calls backend api to fetch identities settings
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {Promise.<HTTPResponseEntity>}
   */
  async fetch() {
    let response = await HTTPService.post(
      this.endpoints.generic + '?api=1&app=imp&group=identities',
      null,
      'identities_fetch',
    );

    return response;
  }

  /**
   * Calls backend api to add/update an identity
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {IdentitiesOptionsEntity} identity identity entity
   *
   * @return {Promise.<HTTPResponseEntity>}
   */
  async save(identity) {
    let request = {
      actionID          : 'update_prefs',
      api               : 1,
      identity          : -1,
      app               : 'imp',
      group             : 'identities',
      horde_prefs_token : SAPOMailConfig.server.security.settings_token,
      default_identity  : (identity.default === true) ? 1 : 0,
      bcc_addr          : identity.bccs,
      from_addr         : identity.email,
      fullname          : identity.name,
      id                : identity.id,
      signature         : identity.dignature || '',
      signature_html    : identity.signature_html,
    }

    if (identity.index !== undefined) {
      request.identity = identity.index;
    }

    let response = await HTTPService.post(
      this.endpoints.generic,
      request,
    );

    return response;
  }

  /**
   * Calls backend api to remove an unconfirmed identity
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {IdentitiesOptionsEntity} identity identity entity
   *
   * @return {Promise.<HTTPResponseEntity>}
   */
  async delete(identity) {
    let request = {
      actionID          : 'update_prefs',
      api               : 1,
      app               : 'imp',
      group             : 'identities',
      horde_prefs_token : SAPOMailConfig.server.security.settings_token,
      delete_identity   : 1,
      identity          : identity.index,
    }

    let response = await HTTPService.post(
      this.endpoints.generic,
      request,
    );

    return response;
  }

  /**
   * Calls backend api to set the default identity
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {IdentitiesOptionsEntity} identity identity entity
   *
   * @return {Promise.<HTTPResponseEntity>}
   */
  async setDefault(identity) {
    let request = {
      identityIndex : identity.index,
    }

    let response = await HTTPService.post(
      this.endpoints.imp + '/setDefaultIdentity',
      request,
      'identities_set_default',
    );

    return response;
  }
}